import { getFlatRoomTypes } from '../../../api'
import { getItemsFromApiResponse } from '../../../utils/api'
import { InputAsyncSelect, InputSelectControl } from '../../Select'

import { FLAT_ROOM_TYPE_SELECT_DROPDOWN_FLOATING_CONFIG } from './FlatRoomTypeSelect.constants'
import { toFlatRoomTypeSelectItems } from './FlatRoomTypeSelect.utils'

function FlatRoomTypeSelect({
  Control = InputSelectControl,
  dropdownFloatingConfig = FLAT_ROOM_TYPE_SELECT_DROPDOWN_FLOATING_CONFIG,
  getData = getFlatRoomTypes,
  getDataItems = getItemsFromApiResponse,
  toPreparedItems = toFlatRoomTypeSelectItems,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      dropdownFloatingConfig={dropdownFloatingConfig}
      getData={getData}
      getDataItems={getDataItems}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default FlatRoomTypeSelect
